import { getTranslation as t } from '../lib/i18n';

const regexSpace = /\s/;
const regexNumber = /^\d+$/;
const regexPositiveInteger = /^[1-9]\d*$/;
const regexOneNumberAndOneAlphabet = /^(?=.*[A-Za-z])(?=.*\d)(?=.)[A-Za-z!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\d]*$/;
const regexOnlyAlphabetAndNumbers = /^[\w\d]+$/;
const regexAtLeastOneAlphabet = /^(?=.*[A-Za-z])[\w\d]+$/;
const regexIPv4AndIPv6Address = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/;
const regexIPLetter = /^[:.0-9]+$/;
const regexNumberPattern = /^-?\d+(\.\d+)?$/;

export const isEmpty = value => !value && value !== 0;
export const notEmpty = value => value || value === 0;
export const stripHtml = (html = '') => {
	if (!html) {
		return '';
	}

	// Browser env
	if (typeof document !== 'undefined') {
		const div = document.createElement('div');

		div.innerHTML = html;

		return (div.textContent || '')
			.replace(/\u200B/g, '') // Zero-width space
			.replace(/\n/g, ' ') // Quill 多段落換行 -> 空白，避免字數計算和送出 contentText 不一致
			.trim();
	}

	return String(html)
		.replace(/<[^>]*>/g, '')
		.replace(/&nbsp;/g, ' ')
		.replace(/\u200B/g, '')
		.replace(/\n/g, ' ')
		.trim();
};

export const regexXMLValidator = /<([^/> ]+)\s*?([^>]*)\s*(?:\/>|>(.*)<\/.+>)/;

export function validatePassword(text) {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !value) {
				callback(`${text}${t('不能为空')}`);
			} else if (value.length < 6) {
				callback(`${text}${t('最少6码')}`);
			} else if (value.length > 20) {
				callback(`${text}${t('最多20码')}`);
			} else if (regexSpace.test(value)) {
				callback(`${text}${t('不能有空白')}`);
			} else if (!regexOneNumberAndOneAlphabet.test(value)) {
				callback(`${text}${t('应至少包含1个英文和数字')}`);
			}
		}

		callback();
	};
}

export function validateCompany() {
	const text = t('公司名称');

	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !value) {
				callback(`${text}${t('不能为空')}`);
			} else if (regexSpace.test(value)) {
				callback(`${text}${t('不能有空白')}`);
			} else if (!regexOnlyAlphabetAndNumbers.test(value)) {
				callback(`${text}${t('僅能输入英文和数字')}`);
			} else if (!regexAtLeastOneAlphabet.test(value)) {
				callback(`${text}${t('应至少包含1个英文')}`);
			}
		}

		callback();
	};
}

export function validateUsername() {
	const text = t('帐号');

	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !value) {
				callback(`${text}${t('不能为空')}`);
			} else if (value.length < 5) {
				callback(`${text}${t('最少5码')}`);
			} else if (value.length > 20) {
				callback(`${text}${t('最多20码')}`);
			} else if (regexSpace.test(value)) {
				callback(`${text}${t('不能有空白')}`);
			} else if (!regexOnlyAlphabetAndNumbers.test(value)) {
				callback(`${text}${t('僅能输入英文和数字')}`);
			} else if (!regexAtLeastOneAlphabet.test(value)) {
				callback(`${text}${t('应至少包含1个英文')}`);
			}

			callback();
		}
	};
}

export function validateIP() {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !value) {
				callback(t('IP不能为空'));
			} else if (!regexIPLetter.test(value)) {
				callback(t('非IP位址'));
			} else if (!regexIPv4AndIPv6Address.test(value)) {
				callback(t('非IP位址'));
			}
		}

		callback();
	};
}

export function validateMessage(type) {
	return function (rule, value, callback) {
		if (rule.required && !value) {
			callback(`${type}${t('不能为空')}`);
		} else if (value && value.length > 500) {
			callback(`${type}${t('最多500个字')}`);
		}

		callback();
	};
}

export function validateGoogleTotp() {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !(value || value === 0)) {
				callback(t('谷歌动态码不能为空'));
			} else if (value.length !== 6) {
				callback(t('谷歌动态码长度6码'));
			}
		}

		callback();
	};
}

export function validateLimitNumber(text) {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !(value || value === 0)) {
				callback(`${text} ${t('不可为空')}`);
			} else if (!regexNumber.test(value) || value === 0) {
				callback(`${text} ${t('需为正整数')}`);
			}
		}

		callback();
	};
}

export function validateInvalidInput(text = '') {
	return function (rule, value, callback) {
		if (regexXMLValidator.test(value)) {
			callback(t('请勿输入语法相关字串'));
		} else if (!value) {
			callback(t('{{text}}不能为空', { text }));
		}

		callback();
	};
}

export function validatePlatformSetName(text = '', targetDataSource, shouldValidateAll, originalName) {
	return function (rule, value, callback) {
		const isDuplicate = targetDataSource.includes(value);

		if (isDuplicate) {
			const isDuplicateOthersName = originalName !== value;

			if (isDuplicateOthersName || shouldValidateAll) {
				callback(t('{{text}}不可重复', { text }));
			}
		} else if (!(value || value === 0)) {
			callback(t('{{text}}不能为空', { text }));
		}

		callback();
	};
}

export function validateDescription(text, limit = 1024) {
	return function (rule, value, callback) {
		if (value?.length > limit) {
			callback(t('{{text}}最多{{inputLimit}}个字', { text: text, inputLimit: limit }));
		} else if (rule.required && !value) {
			callback(t('{{text}}不能为空', { text }));
		}

		callback();
	};
}

export function validateInstruction(limit) {
	return function (rule, value, callback) {
		if (rule.required && !value) {
			callback(t('指令不能为空'));
		} else if (value && value.length > limit) {
			callback(t('指令不能超过{{limit}}字', { limit }));
		}

		callback();
	};
}

export const DATA_DELIMITER_TILDE = '~~~~~';
export const DATA_DELIMITER_EQUAL = '=====';

const DATA_MAX_LENGTH = 1000000; // 100 万字，需與 t('数据不能超过100万字') 文案一致

export function validateKnowledge() {
	return function (rule, value, callback) {
		if (rule.required && !value) {
			return callback(t('数据不能为空'));
		}

		if (!value || !value.trim()) {
			return callback();
		}

		if (value.length > DATA_MAX_LENGTH) {
			return callback(t('数据不能超过100万字'));
		}

		const lines = value.split(/\r?\n/);
		const delimiters = lines.filter(line => line === DATA_DELIMITER_TILDE || line === DATA_DELIMITER_EQUAL);
		const lastMeaningfulLine = [...lines].reverse().find(line => line.trim() !== '');

		if (delimiters.length === 0) {
			return callback(t('至少要有一组 ~~~~~ 与 ====='));
		}

		// 分隔符必須嚴格交替：~~~~~ 在前、===== 在後且成對。
		const isPairedInOrder = delimiters.length % 2 === 0 && delimiters.every(
			(delimiter, index) => delimiter === (index % 2 === 0 ? DATA_DELIMITER_TILDE : DATA_DELIMITER_EQUAL),
		);

		if (!isPairedInOrder) {
			return callback(t('分隔符号 ~~~~~ 与 ===== 需成对出现'));
		}

		if (lastMeaningfulLine !== DATA_DELIMITER_EQUAL) {
			return callback(t('需以 ===== 结尾'));
		}

		return callback();
	};
}

export function validateExistedList(field, existedList = []) {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || value;

		if (shouldValidate) {
			if (rule.required && !value) {
				callback(t(`${field}不能为空`));
			} else if (existedList.indexOf(value) > -1) {
				callback(t(`${field}已存在`));
			}
		}

		callback();
	};
}

export function validateIPs(existedIPs = []) {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || notEmpty(value);

		if (!shouldValidate) {
			callback();
			return;
		}

		const valueList = value?.split(',') || [];
		const existValueList = [];

		if (!valueList.length) {
			callback(t('IP不能为空'));
		}

		valueList.forEach(ip => {
			if (rule.required && isEmpty(ip)) {
				callback(t('IP不能为空'));
			} else if (!regexIPLetter.test(ip)) {
				callback(t('非IP位址'));
			} else if (!regexIPv4AndIPv6Address.test(ip)) {
				callback(t('非IP位址'));
			} else if (existValueList.indexOf(ip) > -1) {
				callback(t('IP已存在'));
			} else if (existedIPs.indexOf(value) > -1) {
				callback(t('IP已存在'));
			}

			existValueList.push(ip);
		});

		callback();
	};
}

export const validateKeywords = (text, limit = 100) => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (!shouldValidate) {
		callback();
		return;
	}

	const valueList = value?.split(';').filter(item => item) || [];
	const totalLength = valueList.reduce((sum, str) => sum + str.length, 0);

	if (!valueList.length) {
		callback(t('{{text}}不能为空', { text }));
	} else if (totalLength > limit) {
		callback(t('{{text}}最多{{inputLimit}}个字', { text: text, inputLimit: limit }));
	}

	valueList.forEach(amount => {
		if (rule.required && isEmpty(amount)) {
			callback(t('{{text}}不能为空', { text }));
		}
	});

	callback();
};

export const validateKeywordGroups = (text, limit = 10) => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (!shouldValidate) {
		callback();
		return;
	}

	const valueList = value?.split(';').filter(item => item) || [];

	if (!valueList.length) {
		callback(t('{{text}}不能为空', { text }));
	} else if (valueList.length > limit) {
		callback(t('{{text}}最多{{inputLimit}}组', { text, inputLimit: limit }));
	}

	valueList.forEach(amount => {
		if (rule.required && isEmpty(amount)) {
			callback(t('{{text}}不能为空', { text }));
		}
	});

	callback();
};

export function validateOnBreakIntervals(existedOnBreakIntervals = []) {
	return function (rule, value, callback) {
		const shouldValidate = rule.required || notEmpty(value);

		if (!shouldValidate) {
			callback();
			return;
		}

		if (rule.required && value === undefined) {
			callback(t('通知时间不能为空'));
		} else if ((value < 1 || value > 60) || !regexPositiveInteger.test(Number(value))) {
			callback(t('需为1~60正整数'));
		} else if (existedOnBreakIntervals.indexOf(value) > -1) {
			callback(t('通知时间不可重复'));
		}

		callback();
	};
}

export const validateLimitText = (text, limit = 255, { isVersionTwo = false } = {}) => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (shouldValidate) {
		if (rule.required && !value) {
			callback(t('{{text}}不能为空', { text }));
		} else if (value && value.length > limit) {
			callback(isVersionTwo ?
				t('{{text}}最多{{limit}}个字元', { text, limit }) :
				t('{{text}}不能超过{{limit}}字元', { text, limit }),
			);
		}
	}

	callback();
};

export const validatePlainTextLengthLimit = (label, limit = 255) => {
	const baseValidator = validateLimitText(label, limit);

	return (rule, value = '', callback) => {
		const plaintext = stripHtml(value);

		return baseValidator(rule, plaintext, callback);
	};
};

export const validateCode = (text, limit = 4) => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (shouldValidate) {
		if (rule.required && !value) {
			callback(t('{{text}}不能为空', { text }));
		} else if (value && value.length > limit) {
			callback(t('{{text}}最多數字{{limit}}碼', { text, limit }));
		} else if (!regexNumber.test(value)) {
			callback(t('{{text}}仅能输入数字', { text }));
		}
	}

	callback();
};

export const validatePlatformCode = () => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (shouldValidate) {
		if (rule.required && !value) {
			callback(t('平台代码不能为空'));
		} else if (value.length < 2) {
			callback(t('平台代码最少2码'));
		} else if (value.length > 5) {
			callback(t('平台代码最多5码'));
		} else if (regexSpace.test(value)) {
			callback(t('平台代码不能有空白'));
		} else if (!regexOnlyAlphabetAndNumbers.test(value)) {
			callback(t('平台代码仅能输入英文和数字'));
		}
	}

	callback();
};

export const validateStringAndNumber = isNumber => (rule, value, callback) => {
	const shouldValidate = rule.required || notEmpty(value);

	if (!shouldValidate) {
		callback();
		return;
	}

	if (rule.required && !value) {
		callback(t('数值/内容不可为空'));
		return;
	}

	if (!isNumber) {
		if (value && value.length > 20) {
			callback(t('内容最多20字元'));
			return;
		}

		callback();
		return;
	}

	if (value && !regexNumberPattern.test(value)) {
		callback(t('数值只能输入数字、负号、小数点'));
		return;
	}

	const [integerPart, decimalPart] = value.replace('-', '').split('.');

	if (integerPart && integerPart.length > 15) {
		callback(t('数值整数最多15位'));
		return;
	}

	if (decimalPart && decimalPart.length > 6) {
		callback(t('数值小数最多6位数'));
		return;
	}

	callback();
};

export const validateTimeEstimate = text => (rule, value, callback) => {
	const shouldValidate = rule.required || value;

	if (shouldValidate) {
		if (rule.required && !(value || value === 0)) {
			callback(t('{{text}}不能为空', { text }));
		} else if (value && value < 180) {
			callback(t('时间设定需至少为 3 分钟'));
		}
	}

	callback();
};

export const validateSkillField = (text, limit) => (rule, value, callback) => {
	if (rule.required && !value) {
		return callback(t('{{text}}不可为空', { text }));
	}

	if (value && value.length > limit) {
		return callback(t('{{text}}最多{{limit}}个字元', { text, limit }));
	}

	callback();
};

export const validateSslUrl = (text, limit) => (rule, value, callback) => {
	if (rule.required && !value) {
		return callback(t('{{text}}不可为空', { text }));
	}

	if (value && !value.startsWith('https://')) {
		return callback(t('{{text}}需以{{prefix}}开头', { text, prefix: 'https://' }));
	}

	if (value && value.length > limit) {
		return callback(t('{{text}}最多{{limit}}个字元', { text, limit }));
	}

	callback();
};

export const validateMerchantCode = () => (rule, value, callback) => {
	if (rule.required && !value) {
		callback(t('商户代码不可为空'));
	} else if (value && value.length > 10) {
		callback(t('商户代码最多10个字元'));
	}

	callback();
};

export const validateSecretKey = () => (rule, value, callback) => {
	if (value && value.length > 250) {
		callback(t('密钥最多250个字元'));
	}

	callback();
};
